export default "__VITE_ASSET__Bxz3YWgv__"